var map = {
	"./bridge/bridge_brand_logo.png": "81c9a",
	"./bridge/bridge_logo.png": "41f9",
	"./coffeeCup/coffeeCup_brand_logo.png": "4194",
	"./coffeeCup/coffeeCup_logo.png": "21f2",
	"./dankoff/dankoff_logo.png": "3fb3",
	"./dobby/dobby_brand_logo.png": "c53b",
	"./dobby/dobby_logo.png": "6845",
	"./hermelin/hermelin_brand_logo.png": "b9db",
	"./hermelin/hermelin_logo.png": "a6f9",
	"./images/dankoff_logo.png": "3215",
	"./images/hermelin_brand_logo.png": "5c43",
	"./lacava/lacava_brand_logo.png": "e86e",
	"./lacava/lacava_logo.png": "af4d",
	"./selecta/selecta_brand_logo.png": "19c7",
	"./selecta/selecta_logo.png": "3d37",
	"./slow/slow_brand_logo.png": "9ea0",
	"./slow/slow_logo.png": "cc1f",
	"./verdi/verdi_brand_logo.png": "ef51",
	"./verdi/verdi_logo.png": "d682"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "08ce";